import { InjectionToken } from '@angular/core';

/**
 * Injectable Window reference so services that call `window.location.reload`,
 * dispatch events, or read `visibilityState` can be unit-tested without
 * touching jsdom global state.
 */
export const WINDOW = new InjectionToken<Window>('window', {
  providedIn: 'root',
  factory: () => window,
});
